import {ValueObject} from '@s-ui/domain'

export class ProductTrackingDataValueObject extends ValueObject {
  #category
  #id
  #price
  #quantity

  constructor({category, id, price, quantity}) {
    super()
    this.#category = category
    this.#id = id
    this.#price = price
    this.#quantity = quantity
  }

  static validate({category, id, price, quantity}) {
    return true
  }

  static createFromPrimitives({category, id, price, quantity}) {
    ProductTrackingDataValueObject.validate({category, id, price, quantity})
    return new ProductTrackingDataValueObject({
      category,
      id,
      price,
      quantity
    })
  }

  get category() {
    return this.#category
  }

  get id() {
    return this.#id
  }

  get price() {
    return this.#price
  }

  get quantity() {
    return this.#quantity
  }

  get value() {
    return {
      category: this.#category,
      id: this.#id,
      price: this.#price,
      quantity: this.#quantity
    }
  }
}
